// extracted by mini-css-extract-plugin
export var mediaFilterBlock = "MediaFilterBlock_mediaFilterBlock__WzN7o";
export var rotate = "MediaFilterBlock_rotate__YFxaU";
export var dotty = "MediaFilterBlock_dotty__eWJ5f";